import PurposeVendorList from './PurposeVendorList'

export default PurposeVendorList
